import {Price} from '../price';

export type UpsellBillingCycle =
  | 'monthly'
  | 'quarterly'
  | 'semiannual'
  | 'yearly';

export const DEFAULT_UPSELL_BILLING_CYCLE: UpsellBillingCycle = 'monthly';

export function findBestPrice(
  token: UpsellBillingCycle,
  prices: Price[],
): Price | undefined {
  if (token === 'monthly') return findMonthlyPrice(prices) ?? prices[0];
  if (token === 'quarterly') return findQuarterlyPrice(prices);
  if (token === 'semiannual') return findSemiannualPrice(prices);
  if (token === 'yearly') return findYearlyPrice(prices) ?? prices[0];
  return prices[0];
}

// Number of months each cycle covers (used for savings calculation)
export const cycleMonths: Record<UpsellBillingCycle, number> = {
  monthly: 1,
  quarterly: 3,
  semiannual: 6,
  yearly: 12,
};

function findYearlyPrice(prices: Price[]) {
  return prices.find(price => {
    if (price.interval === 'month' && price.interval_count >= 12) {
      return price;
    }
    if (price.interval === 'year' && price.interval_count >= 1) {
      return price;
    }
  });
}

function findQuarterlyPrice(prices: Price[]) {
  return prices.find(price => {
    return price.interval === 'month' && price.interval_count === 3;
  });
}

function findSemiannualPrice(prices: Price[]) {
  return prices.find(price => {
    return price.interval === 'month' && price.interval_count === 6;
  });
}

function findMonthlyPrice(prices: Price[]) {
  return prices.find(price => {
    if (price.interval === 'day' && price.interval_count >= 30) {
      return price;
    }
    if (price.interval === 'month' && price.interval_count >= 1) {
      return price;
    }
  });
}
